/** Admin portal route constants (no imports — safe for any module). */

export const ADMIN_BASE_PATH = '/dashboard/admin';

export const ADMIN_DASHBOARD_PATH = '/dashboard/admin';
export const ADMIN_SETUP_2FA_PATH = '/dashboard/admin/setup-2fa';
export const ADMIN_CHANGE_PASSWORD_PATH = '/dashboard/admin/change-password';
export const ADMIN_ACCESS_CONTROL_PATH = '/dashboard/admin/access-control';
export const ADMIN_PROFILE_PATH = '/dashboard/admin/profile';

export const ADMIN_LOGIN_PATH = '/login?admin=1';

/** Legacy admin base — redirects to {@link ADMIN_BASE_PATH} via middleware. */
export const LEGACY_ADMIN_BASE_PATH = '/admin';
